import { CancellationFlowStrategy } from '../CancellationStrategies/enums';

import { CancellationReasonRetenoValue, IReason } from './types';

export const reasons: IReason[] = [
    {
        title: 'subscription.cancellationReason.forgetToCancel.title',
        value: CancellationReasonRetenoValue.ForgetToCancel,
        flow: CancellationFlowStrategy.Reminder,
        shortKey: 'forget_to_cancel',
    },
    {
        title: 'subscription.cancellationReason.expensive.title',
        value: CancellationReasonRetenoValue.TooExpensive,
        flow: CancellationFlowStrategy.Discount,
        shortKey: 'too_expensive',
    },
    {
        title: 'subscription.cancellationReason.noTime.title',
        value: CancellationReasonRetenoValue.HaveNoTime,
        flow: CancellationFlowStrategy.Pause,
        shortKey: 'do_not_have_time',
    },
    {
        title: 'subscription.cancellationReason.noNeed.title',
        value: CancellationReasonRetenoValue.NoNeedForApp,
        flow: CancellationFlowStrategy.Pause,
        shortKey: 'no_need_for_the_app',
    },
    {
        title: 'subscription.cancellationReason.notEnjoying.title',
        value: CancellationReasonRetenoValue.DontLikeWorkouts,
        flow: CancellationFlowStrategy.ChangePlan,
        shortKey: 'not_enjoying',
    },
    {
        title: 'subscription.cancellationReason.notMeetExpectations.title',
        value: CancellationReasonRetenoValue.DoesntMeetExpectations,
        flow: CancellationFlowStrategy.FreeMonth,
        shortKey: 'app_not_meet_my_expectations',
    },
    {
        title: 'subscription.cancellationReason.cantLogin.title',
        value: CancellationReasonRetenoValue.CantLogin,
        flow: CancellationFlowStrategy.HelpLogin,
        shortKey: 'cant_login',
    },
    {
        title: 'subscription.cancellationReason.other.title',
        flow: CancellationFlowStrategy.Discount,
        value: CancellationReasonRetenoValue.Other,
        shortKey: 'other',
    },
];

export const updatedReasons = (isFirstWorkoutCompleted: boolean): IReason[] => [
    {
        title: 'subscription.cancellationReason.forgetToCancel.title',
        value: CancellationReasonRetenoValue.ForgetToCancel,
        flow: CancellationFlowStrategy.Reminder,
        shortKey: 'forget_to_cancel',
    },
    {
        title: 'subscription.cancellationReason.expensive.title',
        value: CancellationReasonRetenoValue.TooExpensive,
        flow: CancellationFlowStrategy.Discount,
        shortKey: 'too_expensive',
    },
    {
        title: 'subscription.cancellationReason.notUsedItMuch.title',
        value: CancellationReasonRetenoValue.NotUsingMuch,
        flow: isFirstWorkoutCompleted ? CancellationFlowStrategy.Pause : CancellationFlowStrategy.Discount,
        shortKey: 'not_using_much',
    },
    {
        title: 'subscription.cancellationReason.wrongWorkouts.title',
        value: CancellationReasonRetenoValue.DontLikeWorkouts,
        flow: CancellationFlowStrategy.ChangePlan,
        shortKey: 'not_enjoying',
    },
    {
        title: 'subscription.cancellationReason.notSeeingResults.title',
        value: CancellationReasonRetenoValue.DoesntMeetExpectations,
        flow: CancellationFlowStrategy.FreeMonth,
        shortKey: 'app_not_meet_my_expectations',
    },
    {
        title: 'subscription.cancellationReason.cantLogin.title',
        value: CancellationReasonRetenoValue.CantLogin,
        flow: CancellationFlowStrategy.HelpLogin,
        shortKey: 'cant_login',
    },
    {
        title: 'subscription.cancellationReason.other.title',
        flow: CancellationFlowStrategy.Discount,
        value: CancellationReasonRetenoValue.Other,
        shortKey: 'other',
    },
];
